import React from 'react';
import { twMerge } from 'tailwind-merge';
import { useRingStyle } from '../../../../tailwind_common/util';
export var WidgetButton = function (props) {
    var handleClick = props.handleClick, className = props.className, children = props.children, disabled = props.disabled;
    var ringStyle = useRingStyle();
    return (React.createElement("button", { className: twMerge('tw-focus box-border rounded-md  bg-primary px-2 py-1.75 text-xs text-white shadow-widget-button', className), onClick: handleClick, style: ringStyle, disabled: disabled }, children));
};
export default WidgetButton;
